import { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { get_auth_user_data } from "../../redux/auth/auth.selectors";
import Table from "./components/Table";
import UserData from "./components/UserData";
import axiosInstance from "../../http-common";
// import { throttle } from "lodash";
// import { PO_Backlog_Service } from "../../redux/po_backlog/po_backlog.services";
import { fetch_hidden_fields, logout_if_403 } from "../../util";
import { load_adhoc_analyst_data, load_ongoing_analyst_data } from "./utilis/analystServices";

function AnalystHome() {
  const { auth } = useSelector((state) => state);
  const user_data = useSelector(get_auth_user_data);
  // console.log(user_data);
  const analyst_name = `${user_data.name}`;

  const backend_url = process.env.REACT_APP_BACKEND_MAIN_URL;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [, setData2] = useState([]);
  const [adhocData, setAdhocData] = useState([]);
  const [ongoingData, setOngoingData] = useState([]);


  useEffect(() => {
    if (!auth.isAuth) navigate("/");
    apiCall(1);
    const analyst_id = user_data.employee_id === "." ? `${user_data.name} ${user_data.last_name}` : `${user_data.name} ${user_data.last_name}_${user_data.employee_id}`;
    // console.log(analyst_id);
    load_adhoc_analyst_data(setAdhocData, analyst_id);
    load_ongoing_analyst_data(setOngoingData, analyst_id);
    // Throttle the API call
    // const throttledApiCall = throttle(() => apiCall(8), 30000);

    // // Call every 30 seconds
    // const interval = setInterval(() => {
    //   throttledApiCall();
    // }, 30000);

    // Cleanup interval on component unmount
    // return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // console.log(adhocData, ongoingData);
  const [user, set_user] = useState({
    Designation: "",
    analyst_name: "",
    analyst_id: "",
    employee_id: "",
  });

  const apiCall = async (val) => {
    const emp_name = analyst_name;
    const emp_id = user_data.employee_id;
    const analyst_id = user_data.employee_id === "." ? `${user_data.name} ${user_data.last_name}` : `${user_data.name} ${user_data.last_name}_${user_data.employee_id}`;
    set_user(prev => ({
      ...prev,
      analyst_id,
      employee_id: emp_id,
      analyst_name: emp_name
    }));
    try {
      // const response_user_data =
      //   await fetch(`${backend_url}/v1/qc/analyst_details?analyst_id=${analyst_id}`);
      const response_user_data = await axiosInstance.get(`v1/qc/analyst_details?analyst_id=${analyst_id}`);
      // const response_sample_types = await PO_Backlog_Service.sample_types_get();
      const d = await response_user_data?.data;
      if (d.data && d.data?.length > 0) {
        const { Designation, analyst_name } = d.data[0];
        set_user(prev => ({
          ...prev,
          Designation,
          analyst_name
        }));
      }
      const body = JSON.stringify({ analyst_id: analyst_id });
      const response = await axiosInstance.post(
        `${backend_url}/v1/qc/get_qc_schedule_for_analyst/` + val, body, {
        headers: { "Content-Type": "application/json" },
      });
      // console.log(response);
      // const d = await response?.json();
      const result = await response?.data;
      // console.log(d);
      if (result !== "") {
        let x = [], y = [];
        for (let i = 0; i < result.qc_schedule.length; i++) {
          delete result.qc_schedule[i]['qc_review'];
          delete result.qc_schedule[i]['analyst_required'];
          if (new Date(result.qc_schedule[i].pre_start_time).getDate() !== new Date().getDate()) {
            y.push(result.qc_schedule[i]);
          } else x.push(result.qc_schedule[i]);
        }
        // console.log({ x, y, d: d.qc_schedule });
        setData(x);
        setData2(y);
      }
      else console.log("no data received");

    } catch (error) {
      logout_if_403(error);
      console.log(error);
    }
  };

  // console.log(localStorage.getItem("client_id"))

  const [fetched_hidden_fields, set_fetched_hidden_fields] = useState(false);

  const [hidden_fields, set_hidden_fields] = useState({
    open_po: [],
    sample_status: [],
    schedule: [],
  });

  useEffect(() => {
    fetch_hidden_fields(set_hidden_fields).then(() => {
      set_fetched_hidden_fields(true);
    });
  }, []);
  console.log(data);
  return (
    <>
      <div className="flex flex-col gap-3">
        {/* <h1 className="text-4xl font-bold text-[#084298]">Home</h1> */}
        {/* <Topnav Id={props.Id} /> */}
        <UserData employee_id={user.employee_id} analyst_name={user.analyst_name} designation={user.Designation} />
        <div className="flex flex-col pl-2 pr-2 gap-3">
          <div className="flex flex-col justify-start p-2 bg-white rounded-xl shadow-xl">
            <h1 className="text-2xl font-bold text-[#084298] p-3">
              In Progress Tasks
            </h1>
            {ongoingData && ongoingData.length >= 0 && fetched_hidden_fields ? (
              <Table data={ongoingData} today={true} hidden_fields={hidden_fields?.schedule} aria_label={"ongoing_table"} initialState={{
                pinnedColumns: {
                  left: ["batch_no", "material_name"],
                  right: ["analyst_id", "machine_id", "status", "remark"],
                },
              }} />
            ) : (
              <h1 className="text-xl font-bold text-black p-3">
                No In Progress Tasks
              </h1>
            )}
          </div>
          <div className="flex flex-col justify-start p-2 bg-white rounded-xl shadow-xl">
            <h1 className="text-2xl font-bold text-[#084298] p-3">
              Tasks For Today
            </h1>
            {data && data.length >= 0 && fetched_hidden_fields ? (
              <Table data={data} today={true} has_new_schedule_row hidden_fields={hidden_fields?.schedule} aria_label={"today_table"} initialState={{
                pinnedColumns: {
                  left: ["batch_no", "material_name"],
                  right: ["analyst_id", "machine_id", "status", "remark"],
                },
              }} />
            ) : (
              <h1 className="text-xl font-bold text-black p-3">
                No Task for Today
              </h1>
            )}
          </div>
          {/* <div className="flex flex-col justify-start p-2 bg-white rounded-xl shadow-xl">
            <h1 className="text-2xl font-bold text-[#084298] p-3">
              Other Tasks
            </h1>
            {data2 && data2.length && fetched_hidden_fields ? (
              <Table data={data2} today={false} hidden_fields={hidden_fields?.schedule} aria_label={"other_table"} />
            ) : (
              <h1 className="text-xl font-bold text-black p-3">
                No tasks for rest of the week
              </h1>
            )}
          </div> */}
          <div className="flex flex-col justify-start p-2 bg-white rounded-xl shadow-xl">
            <h1 className="text-2xl font-bold text-[#084298] p-3">
              Tasks Pending Approval
            </h1>
            {adhocData && adhocData.length && fetched_hidden_fields ? (
              <Table data={adhocData} today={false} hidden_fields={[...hidden_fields?.schedule, "status"]} aria_label={"adhoc_table"} initialState={{
                pinnedColumns: {
                  left: ["batch_no", "material_name"],
                  right: ["analyst_id", "machine_id", "status"],
                },
              }} />
            ) : (
              <h1 className="text-xl font-bold text-black p-3">
                No tasks
              </h1>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AnalystHome;
